import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'alRemovewhitespace'
})
export class AlRemoveWhitespacePipe implements PipeTransform {


  transform(text: string): string {
    if (!text || !text.length) { return text; }
    
    return text.replace(/\s/g, '_');
  }

}
